import React, { useState } from 'react';
import { View } from 'react-native';

import { Text, WarningDialog } from '../../components';
import { Card, SecondaryButton, StatusBadge } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const STATUS_PRESENTATION = {
	QUEUED: { label: 'Queued', tone: 'primary' },
	COMPLETED: { label: 'Sent to printer', tone: 'success' },
	FAILED: { label: 'Failed', tone: 'danger' },
	UNCERTAIN: { label: 'Check printer', tone: 'warning' },
};

const WarehousePrintJobStatus = ({ job, labelName, onReprint, isSubmitting }) => {
	const styles = useThemedStyles(createStyles);
	const [isReprintDialogOpen, setIsReprintDialogOpen] = useState(false);
	if (!job) {
		return null;
	}

	const presentation = STATUS_PRESENTATION[job.status] || STATUS_PRESENTATION.QUEUED;
	const canReprint = ['COMPLETED', 'FAILED', 'UNCERTAIN'].includes(job.status) && !String(job.id).startsWith('offline-');
	const warehouseLabel = job.warehouse?.name ? ` · ${job.warehouse.name}` : '';

	return (
		<Card style={styles.container}>
			<View style={styles.headingRow}>
				<StatusBadge size="small" {...presentation} />
				<Text style={styles.heading}>{labelName}{job.isReprint ? ' reprint' : ''}{warehouseLabel}</Text>
			</View>
			<Text style={styles.message}>{job.statusMessage || 'Waiting for an update from the warehouse printer.'}</Text>
			{
				canReprint && (
					<SecondaryButton
						label="Reprint label"
						icon="printer"
						onPress={() => setIsReprintDialogOpen(true)}
						loading={isSubmitting}
					/>
				)
			}
			<WarningDialog
				title={`Reprint ${labelName.toLowerCase()}?`}
				texts={[
					'Check the printer first. Reprinting a completed or uncertain job can produce a duplicate physical label.',
					'This creates a separate, recorded print attempt.',
				]}
				isOpen={isReprintDialogOpen}
				setIsOpen={setIsReprintDialogOpen}
				leftButtonText="Confirm reprint"
				onClick={() => onReprint(`Picker confirmed reprint after checking ${job.status.toLowerCase()} job`)}
			/>
		</Card>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		gap: space.sm,
	},
	headingRow: {
		alignItems: 'center',
		flexDirection: 'row',
		gap: space.sm,
	},
	heading: {
		...type.bodySmallSemibold,
		color: colors.text,
		flex: 1,
	},
	message: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default WarehousePrintJobStatus;
